import axios, { AxiosResponse } from "axios"
import { GetDescuadreSaldosAsientosContablesDtoProps } from "./DTOs/GetDescuadreSaldosAsientosContablesDto"
import { GetLineasAsientosConciliablesDtoProps } from "./DTOs/GetLineasAsientosConciliablesDto"
import { LineaAsientoContableConciliablesDtoAdapter } from "./LineaAsientoContable.adapter"
import { GetLineasAsientosConciliablesDtoIPagedEnumerableProps } from "./Schemas/GetLineasAsientosConciliablesDtoIPagedEnumerable"

interface GetLineasAsientosConciliablesDtoQueryParamsProps {
  CuentaContableId: string
  FechaLowerLimit?: string
  FechaUpperLimit?: string
  ImporteMovimiento: number
  Keyword?: string
  SortingCriteria?: string
  MaxResultCount?: number
  SkipCount?: number
}

export async function getLineaAsientoContableConciliables(
  queryParams?: GetLineasAsientosConciliablesDtoQueryParamsProps
): Promise<GetLineasAsientosConciliablesDtoIPagedEnumerableProps> {
  const {
    data,
  }: { data: GetLineasAsientosConciliablesDtoIPagedEnumerableProps } =
    await axios.get(`/LineaAsientoContable/conciliables${queryParams}`)
  return {
    currentPage: data.currentPage,
    items: data.items?.map(
      (lineaAsiento: GetLineasAsientosConciliablesDtoProps) =>
        LineaAsientoContableConciliablesDtoAdapter(lineaAsiento)
    ),
    totalCount: data.totalCount,
  }
}

export async function getLineaAsientoContableDescuadreSaldos(): Promise<
  GetDescuadreSaldosAsientosContablesDtoProps[]
> {
  const { data }: { data: GetDescuadreSaldosAsientosContablesDtoProps[] } =
    await axios.get(`/LineaAsientoContable/descuadre-saldos`)
  return data
}

export async function postLineaAsientoContableRecalcularSaldos(
  queryParams: GetDescuadreSaldosAsientosContablesDtoProps[]
): Promise<AxiosResponse> {
  const resp = await axios.post(`/LineaAsientoContable/recalcular-saldos`, {
    cuentasContablesDescuadradas: queryParams,
  })
  return resp
}
